import { styled } from '@mui/material'

export const DatasetHistoryWrapper = styled('div')`
  padding: 15px 0;
  display: flex;
  flex-direction: column;
  gap: 30px;
  background-color: #fff;
  height: 100%;
  border-top: 1px solid #ddd;
`

export const Alert = styled('div')`
  background-color: #feeceb;
  padding: 10px;
  border-radius: 8px;
`

export const SuccessAlert = styled(Alert)`
  background-color: #edf7ed;
`

export const AlertTitle = styled('div')`
  color: #e31b0c;
  font-weight: 500;
`

export const SuccessAlertTitle = styled(AlertTitle)`
  color: #4caf50;
`

export const InProgressAlertTitle = styled(AlertTitle)`
  color: #000000;
`

export const HeightLimitedImg = styled('img')`
  max-height: 24px;
  margin-right: 12px;
`
